var _style, _circle, _path, _g, _polygon, _path2, _circle2, _path3, _g2, _path4, _path5, _circle3, _path6, _g3, _path7, _rect, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValores(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:url(#SVGID_3_);}\r\n\t.st4{fill:url(#SVGID_4_);}\r\n\t.st5{fill:url(#SVGID_5_);}\r\n\t.st6{fill:url(#SVGID_6_);}\r\n\t.st7{fill:url(#SVGID_7_);}\r\n\t.st8{fill:url(#SVGID_8_);}\r\n\t.st9{fill:url(#SVGID_9_);}\r\n\t.st10{fill:url(#SVGID_10_);}\r\n\t.st11{fill:url(#SVGID_11_);}\r\n\t.st12{fill:url(#SVGID_12_);}\r\n\t.st13{fill:url(#SVGID_13_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.25
    },
    width: 490,
    height: 490,
    xlinkHref: "D2038FC7.png",
    transform: "matrix(0.24 0 0 0.24 -266.0958 16.68)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -316.9708,
    y1: 125.0826,
    x2: -263.8252,
    y2: 178.2283,
    gradientTransform: "matrix(0.7071 0.7071 -0.7071 0.7071 98.3482 181.3146)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#55BEC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C728A"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: -214.2,
    cy: 68.6,
    r: 43.7
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -216.8942,
    y1: 130.4357,
    x2: -288.7684,
    y2: 137.764,
    gradientTransform: "matrix(0.7071 0.7071 -0.7071 0.7071 98.3482 181.3146)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FC1AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#55BEC0"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-130.2,90.3l-21.7-21.7c-2.2-2.2-5.7-2.5-8.1-0.5c-1.3,1.2-2,2.8-2,4.4c0,1.5,0.6,3,1.7,4.1l13.3,13.3l-54,0 c-10,6.1-23.4,4.6-31.7-4.6c-8.5-9.4-8.7-23.8-0.4-33.4c0,0,0,0,0,0l-6.5-6.5c-5.6,6.2-9.1,14.5-9,23.6 c0.1,19.2,16.1,34.6,35.3,34.6l64.5,0l-11.5,11.5c-2.3,2.3-2.3,6.1,0.1,8.4c2.3,2.1,6.1,1.9,8.3-0.3l21.6-21.6 C-127.1,98.5-127.1,93.5-130.2,90.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.25
    },
    width: 335,
    height: 336,
    xlinkHref: "D2038FC5.png",
    transform: "matrix(0.24 0 0 0.24 -247.3758 35.16)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: -214.2,
    cy: 68.5,
    r: 25.2
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -224.2574,
    y1: 59.579,
    x2: -198.1987,
    y2: 85.6377
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#55BEC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C728A"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "-209.9,60.2 -209.9,57.6 -206.5,57.6 -207.4,56 -206.5,54.2 -210.4,54.2 -210.4,54.2 -210.8,54.2  -210.8,60.2 -215.4,66.6 -220.2,63.2 -230,77 -197.6,77  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.5,
    y1: 75,
    x2: 147.5,
    y2: 75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7245E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B21547"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M75,147.5C35,147.5,2.5,115,2.5,75C2.5,35,35,2.5,75,2.5c40,0,72.5,32.5,72.5,72.5 C147.5,115,115,147.5,75,147.5z M75,5.3C36.6,5.3,5.3,36.6,5.3,75c0,38.4,31.2,69.7,69.7,69.7c38.4,0,69.7-31.2,69.7-69.7 C144.7,36.6,113.4,5.3,75,5.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.25
    },
    width: 490,
    height: 490,
    xlinkHref: "D2038FCB.png",
    transform: "matrix(0.24 0 0 0.24 -270.7535 120.5116)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -246.8437,
    y1: 201.7969,
    x2: -193.698,
    y2: 254.9426,
    gradientTransform: "matrix(0.7071 0.7071 -0.7071 0.7071 98.3482 181.3146)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00862548,
    style: {
      stopColor: "#F59A1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#EB5F26"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: -218.9,
    cy: 172.4,
    r: 43.7
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -206.7777,
    y1: 189.1748,
    x2: -140.3036,
    y2: 189.1748
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00862548,
    style: {
      stopColor: "#F59A1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCE32"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-134.9,194.2l-21.7-21.7c-2.2-2.2-5.7-2.5-8.1-0.5c-1.3,1.2-2,2.8-2,4.4c0,1.5,0.6,3,1.7,4.1l13.3,13.3l-54,0 c-10,6.1-23.4,4.6-31.7-4.6c-8.5-9.4-8.7-23.8-0.4-33.4c0,0,0,0,0,0l-6.5-6.5c-5.6,6.2-9.1,14.5-9,23.6 c0.1,19.2,16.1,34.6,35.3,34.6l64.5,0l-11.5,11.5c-2.3,2.3-2.3,6.1,0.1,8.4c2.3,2.1,6.1,1.9,8.3-0.3l21.6-21.6 C-131.8,202.4-131.8,197.3-134.9,194.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.25
    },
    width: 335,
    height: 336,
    xlinkHref: "D2038FCD.png",
    transform: "matrix(0.24 0 0 0.24 -252.0335 138.9916)"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: -218.8,
    cy: 172.3,
    r: 25.2
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -223.4413,
    y1: 172.9969,
    x2: -217.09,
    y2: 172.9969
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00862548,
    style: {
      stopColor: "#F59A1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#EB5F26"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M-220.3,169.8c-1.8,0-3.2,1.4-3.2,3.2c0,1.7,1.4,3.2,3.2,3.2c1.7,0,3.2-1.4,3.2-3.2 C-217.1,171.2-218.5,169.8-220.3,169.8z M-220.8,173.4c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9 S-220.3,173.4-220.8,173.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: -235.5513,
    y1: 173.6883,
    x2: -203.597,
    y2: 173.6883
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00862548,
    style: {
      stopColor: "#F59A1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#EB5F26"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-219.6,165.8c-8.8,0-16,7.9-16,7.9s7.2,7.9,16,7.9c8.8,0,16-7.9,16-7.9S-210.7,165.8-219.6,165.8z  M-219.6,180c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c3.5,0,6.3,2.8,6.3,6.3C-213.3,177.2-216.1,180-219.6,180z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.25
    },
    width: 490,
    height: 490,
    xlinkHref: "D2038FCF.png",
    transform: "matrix(0.24 0 0 0.24 1.8 16.68)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.5024,
    y1: 50.4026,
    x2: 81.5636,
    y2: 96.4638
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7245E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B21547"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 53.7,
    cy: 68.6,
    r: 43.7
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.6787,
    y1: 85.3432,
    x2: 136.0665,
    y2: 85.3432
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7245E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E94190"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M137.6,90.3L116,68.7c-2.2-2.2-5.7-2.5-8.1-0.5c-1.3,1.2-2,2.8-2,4.4c0,1.5,0.6,3,1.7,4.1L120.8,90l-54,0 c-10,6.1-23.4,4.6-31.7-4.6C26.6,76,26.4,61.6,34.7,52c0,0,0,0,0,0l-6.5-6.5c-5.6,6.2-9.1,14.5-9,23.6 c0.1,19.2,16.1,34.6,35.3,34.6l64.5,0l-11.5,11.5c-2.3,2.3-2.3,6.1,0.1,8.4c2.3,2.1,6.1,1.9,8.3-0.3l21.6-21.6 C140.8,98.5,140.8,93.5,137.6,90.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.25
    },
    width: 335,
    height: 336,
    xlinkHref: "D2038FCC.png",
    transform: "matrix(0.24 0 0 0.24 20.52 35.16)"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 53.7,
    cy: 68.5,
    r: 25.2
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.5041,
    y1: 56.6796,
    x2: 61.5867,
    y2: 80.7623
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7245E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B21547"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M66.9,72.4c-0.3-0.3-0.7-0.4-1.1-0.3l-6.6,2.2c-1.1,0.4-2.2,0.4-3.3,0.1L48.9,73l4.8-1.1 c0.7-0.2,1.2-0.8,1.2-1.5c0-0.9-0.7-1.6-1.6-1.6h-4c-0.7,0-1.5,0.2-2.1,0.4l-2.5,1.1v7.2l10.8,0.9c1.8,0.1,3.6-0.2,5.1-1.1 l6.1-3.2C67.3,73.8,67.4,72.9,66.9,72.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.0689,
    y1: 63.1149,
    x2: 55.1514,
    y2: 87.1975
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7245E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B21547"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.3,
    y: 69.5,
    className: "st12",
    width: 3,
    height: 8.7
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.8885,
    y1: 48.2953,
    x2: 69.971,
    y2: 72.3778
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7245E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B21547"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "52.1,57 48.7,60.6 58.1,69.9 60.7,67.4 67.4,60.6 64.1,57  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValores);
export default __webpack_public_path__ + "static/media/valores.b7f5508392bca09293c37bc480d5aa04.svg";
export { ForwardRef as ReactComponent };